import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';

export default function CollegeAddUsers() {

  const [errors, setErrors] = useState({});
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [userTypeId, setUserTypeId] = useState([]);
  const [username, setUsername] = useState('');
  const [flag, setflag] = useState(false);
  const [disciplineId, setDisciplineChange] = useState(null);
  const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [collegedisciplinetype, setCollegeDisciplineTypeChange] = useState(null);

  const [disciplineName, setDisciplineNameChange] = useState(null);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [reloadUserID, setReloadUserID] = useState(false);
  const [getGenerateUserID, setGenerateUserID] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [userid, setUserID] = useState('');
  const [password, setPassword] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [submittedUserID, setSubmittedUserID] = useState('');
  const [submittedPassword, setSubmittedPassword] = useState('');
  const [isFirstSubmit, setFirstSubmit] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");

  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/");
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        //Old Discipline API
        //const response = await http.get(`/College/getSFASideCollegeDisciplines`, {
        const response = await http.get(`/College/getCollegeDisciplinesfor_SFA_DEO_Panel`, {
          params: {
            limit: '500',
            college_id: cid
          }
        });
        if (response.data.status_code === 'ERR5') {
          setflag(true);
        }
        //setDisciplineData(response.data);
        if (Array.isArray(response.data)) {
          setDisciplineData(response.data);
        } else {
          setDisciplineData([]); // fallback to empty array
        }
      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchData();
  }, []);

  const handleUserTypeChange = (selectedOption) => {
    setSelectedUserType(selectedOption);
    setUserTypeId(selectedOption.value);

    if (selectedOption.value === 23 && selectedOption.value === 24) {
      setDisciplineChange(null);
      setDisciplineNameChange(null);
      setDisciplineTypeChange(null);
      setCollegeDisciplineTypeChange(null);
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.discipline;
        return newErrors;
      });
    }

    generatePassword();
  };

  useEffect(() => {
    if (userTypeId === '' || userTypeId === 0) {
      toast.error("Please select User Role");
      return;
    }

    const getcollegeUserIDGeneraion = () => {
      http.get(`/College/getcollegeUserIDGeneraion`, {
        params: {
          college_id: cid,
          user_type: userTypeId
        }
      })
        .then((response) => {
          if (response.data.status_code === 'ERR5') {
            setflag(true);
            toast.error("Unable to generate User ID");
            return;
          }

          if (response.data.new_user_id) {
            setGenerateUserID(response.data.new_user_id);
            setUserID(response.data.new_user_id);
            //setErrors(prev => ({ ...prev, userid: "" }));
          } else {
            toast.error("User ID not received");
          }
        })
        .catch((error) => {
          const status = error.response?.data?.http_status;
          const code = error.response?.data?.status_code;

          if (status === 401 && code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/college/");
            }, 5000);
          } else if (status === 429 && code === "ERR33") {
            toast.error(error.response.data.message);
          } else {
            toast.error("Something went wrong");
          }
        });
    };
    if (userTypeId != '' || reloadUserID) {
      getcollegeUserIDGeneraion();
    }
  }, [userTypeId, reloadUserID]);

  const validateForm = () => {
    let hasError = false;
    let updatedErrors = {};

    if (!username) {
      updatedErrors.username = 'User Name is required.';
      hasError = true;
    }

    if (userTypeId !== 23  && userTypeId !== 24 && !disciplineId) {
      updatedErrors.discipline = 'Discipline is required.';
      hasError = true;
    }
    if (!selectedUserType) {
      updatedErrors.userType = 'User Type is required.';
      hasError = true;
    }

    if (!email.trim()) {
      updatedErrors.email = 'Email is required.';
      hasError = true;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      updatedErrors.email = 'Enter a valid email address.';
      hasError = true;
    }

    if (!phone) {
      updatedErrors.phone = 'Phone No. is required.';
      hasError = true;
    }
    else {
      // Accepts: 10 digits OR +91 followed by 10 digits
      //const phoneRegex = /^(?:\+91)?[6-9]\d{9}$/;
      const phoneRegex = /^(?:\+91)?\d{10}$/;

      if (!phoneRegex.test(phone)) {
        updatedErrors.phone = 'Enter a valid Phone number (with or without +91).';
        hasError = true;
      }
    }

    if (!userid) {
      updatedErrors.userid = 'Login User ID is required.';
      hasError = true;
    }
    if (!password) {
      updatedErrors.password = 'Password is required.';
      hasError = true;
    } else {
      //const passwordRegex = /^[A-Z](?=.*[a-z])(?=.*[0-9!@#$])[a-z0-9!@#$]{7,}$/;

      //old code
      //const passwordRegex = /^[A-Z](?=.*[a-z])[A-Za-z0-9\S]{6,10}[0-9\W]$/;
      //old code end

      const passwordRegex = /^(?=.{8,12}$)(?=[A-Z])[A-Z](?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;

      if (password.length < 8 || password.length > 12 || !passwordRegex.test(password)) {

        //old code
        //updatedErrors.password = 'Password must be 8-12 characters, start with uppercase, followed by lowercase, and end with number/symbol.';
        //old code end

        updatedErrors.password = 'Password must be 8-12 characters, start with uppercase, followed by lowercase, number and symbol.';

        hasError = true;
      }
    }

    setErrors(updatedErrors);
    return !hasError;
  };

  const handleDisciplineChange = (selectedOption) => {
    setDisciplineChange(selectedOption.did);
    setDisciplineNameChange(selectedOption.value);
    setDisciplineTypeChange(selectedOption.type);
    setCollegeDisciplineTypeChange(selectedOption.college_discipline_id);
  };


  const handleCancel = () => {
    setFirstSubmit(!isFirstSubmit);
    window.location.reload();
  }

  const cancelForm = () => {
    window.location.reload();
  };

  //Old Code
  {/* const generatePassword = () => {
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    //const symbols = "!@#$%^&*()~";
    //const symbols = `!@#$%^&*()_+-=[]{}|;:'",.<>?/\\~\``;
    const symbols = `!@#$%^&*()`;
    const allChars = lower + numbers + symbols;

    let newPassword = "";

    newPassword += upper.charAt(Math.floor(Math.random() * upper.length)); // first capital
    for (let i = 0; i < 6; i++) {
      newPassword += allChars.charAt(Math.floor(Math.random() * allChars.length));
    }
    // last char random symbol/number
    newPassword += symbols.charAt(Math.floor(Math.random() * symbols.length));

    setPassword(newPassword);
    evaluateStrength(newPassword);
  };
  */}
  //Old code End

  const generatePassword = () => {
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const symbols = "!@#$%^&*()";

    let newPassword = "";

    //First character: uppercase
    newPassword += upper.charAt(Math.floor(Math.random() * upper.length));

    //Ensure at least one lowercase, one number, one symbol
    newPassword += lower.charAt(Math.floor(Math.random() * lower.length));
    newPassword += numbers.charAt(Math.floor(Math.random() * numbers.length));
    newPassword += symbols.charAt(Math.floor(Math.random() * symbols.length));

    //Fill remaining characters (to make 8–12 total)
    const allChars = lower + numbers + symbols;
    const remainingLength = Math.floor(Math.random() * 5) + 4; // ensures total 8–12
    for (let i = 0; i < remainingLength; i++) {
      newPassword += allChars.charAt(Math.floor(Math.random() * allChars.length));
    }

    //Shuffle all except the first uppercase character
    const rest = newPassword.slice(1).split('').sort(() => Math.random() - 0.5).join('');
    newPassword = newPassword[0] + rest;

    setPassword(newPassword);
    evaluateStrength(newPassword);
  };

  const evaluateStrength = (password) => {
    const lengthValid = password.length >= 8 && password.length <= 12;
    const startsWithUpper = /^[A-Z]/.test(password);
    const hasLower = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);
    //const hasSymbol = /[!@#$]/.test(password);
    const hasSymbol = /[^A-Za-z0-9]/.test(password);

    if (!lengthValid || !startsWithUpper) {
      setPasswordStrength("Weak");
      return;
    }

    if (hasLower && (hasNumber || hasSymbol)) {
      if (hasNumber && hasSymbol && password.length >= 10) {
        setPasswordStrength("Very Strong");
      } else {
        setPasswordStrength("Strong");
      }
    } else {
      setPasswordStrength("Weak");
    }
  };

  const copyUserIDToClipboard = () => {
    if (userid) {
      navigator.clipboard.writeText(userid).then(
        () => toast.success("User ID copied to clipboard!"),
        () => toast.error("Failed to copy User ID.")
      );
    }
    else {
      toast.error("Please fill fields");
    }
  };
  const copyToClipboard = () => {
    if (password) {
      navigator.clipboard.writeText(password).then(
        () => toast.success("Password copied to clipboard!"),
        () => toast.error("Failed to copy password.")
      );
    }
    else {
      toast.error("Please generate password");
    }
  };

  let cid = localStorage.getItem("collegeid");

  const handlefirstsubmit = () => {
    if (!validateForm()) {
      toast.error("Please fill mandatory fields");
      return;
    }
    setSubmittedUserID(userid);
    setSubmittedPassword(password);
    //setShowConfirmModal(true);
    handleSaveUserData();
  };

  const handleSaveUserData = () => {

    if (userTypeId === 23) {
      const aes_payloads = {
        uname: username,
        phoneNo: phone,
        user_type: userTypeId,
        user_id: userid,
        college_id: cid,
        email: email,
        password: password
      };

      http.post('/College/saveAESCollegeUser', aes_payloads)
        .then((response) => {

          if (response.data.status_code === 'ERR43' && response.data.http_status === 401) {
            toast.error("Email ID already exists");

            return;
          }
          if (response.data.status_code === 'ERR64' && response.data.http_status === 500) {
            toast.error("Something went wrong. Please try again");
            setReloadUserID(true);
            setErrors(prev => ({
              ...prev,
              userid: "Note: New user ID is generated. Please submit again"
            }));
            return;
          }

          if (response.data.status_code === 'MSG1') {
            toast.success("User data inserted successfully");
            setTimeout(() => {
              setShowConfirmModal(true);
            }, 1000);
          } else if (response.data.status_code === 'CNF') {
            toast.error(response.data.message);
            setShowConfirmModal(false);
          } else {
            toast.error("Failed to save user data");
            setShowConfirmModal(false);

          }
        })
        .catch((error) => {
          setReloadUserID(false);
          setShowConfirmModal(false);

          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";

          if (status === 500 && error.response?.data?.status_code === "ERR5") {
            toast.error(message);
          } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/college/"), 5000);
          } else if (error.response?.data?.status_code === 'ERR64' && status === 500) {
            toast.error("Something went wrong. Please try again");
            setReloadUserID(true);
            setErrors(prev => ({
              ...prev,
              userid: "Note: New user ID is generated. Please submit again"
            }));
          }
          if (error.response?.data?.http_status === 401 && error.response?.data?.status_code === "ERR43") {
            toast.error(message);
          }
          else {
            toast.error("Something went wrong");
          }
        });
    }

    else if(userTypeId === 24){
      // Actual submit begins
      const payloads = {
        uname: username,
        phoneNo: phone,
        user_type: userTypeId,
        user_id: userid,
        college_id: cid,
        email: email,
        password: password
      };

      http.post('/College/saveCollegeIMUUserData', payloads)
        .then((response) => {

          if (response.data.status_code === 'ERR43' && response.data.http_status === 401) {
            toast.error("Email ID already exists");

            return;
          }
          if (response.data.status_code === 'ERR64' && response.data.http_status === 500) {
            toast.error("Something went wrong. Please try again");
            setReloadUserID(true);
            setErrors(prev => ({
              ...prev,
              userid: "Note: New user ID is generated. Please submit again"
            }));
            return;
          }


          if (response.data.status_code === 'MSG11') {
            toast.success("User data inserted successfully");
            setTimeout(() => {
              setShowConfirmModal(true);
            }, 1000); // 2000ms = 2 seconds

          } else {
            toast.error("Failed to save User Data");
            setShowConfirmModal(false);

          }
        })
        .catch((error) => {
          setReloadUserID(false);
          setShowConfirmModal(false);

          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";

          if (status === 500 && error.response?.data?.status_code === "ERR5") {
            toast.error(message);
          } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/college/"), 5000);
          } else if (error.response?.data?.status_code === 'ERR64' && status === 500) {
            toast.error("Something went wrong. Please try again");
            setReloadUserID(true);
            setErrors(prev => ({
              ...prev,
              userid: "Note: New user ID is generated. Please submit again"
            }));
          }
          if (error.response?.data?.http_status === 401 && error.response?.data?.status_code === "ERR43") {
            toast.error(message);
          }
          else {
            toast.error("Something went wrong");
          }
        });
    }
    else {
      // Actual submit begins
      const payloads = {
        uname: username,
        phoneNo: phone,
        discipline_id: disciplineId,
        disciplinetype: disciplinetype,
        collegedisciplinetype: collegedisciplinetype,
        user_type: userTypeId,
        user_id: userid,
        college_id: cid,
        email: email,
        password: password
      };

      http.post('/College/saveCollegeUserData', payloads)
        .then((response) => {

          if (response.data.status_code === 'ERR43' && response.data.http_status === 401) {
            toast.error("Email ID already exists");

            return;
          }
          if (response.data.status_code === 'ERR64' && response.data.http_status === 500) {
            toast.error("Something went wrong. Please try again");
            setReloadUserID(true);
            setErrors(prev => ({
              ...prev,
              userid: "Note: New user ID is generated. Please submit again"
            }));
            return;
          }


          if (response.data.status_code === 'MSG11') {
            toast.success("User data inserted successfully");
            setTimeout(() => {
              setShowConfirmModal(true);
            }, 1000); // 2000ms = 2 seconds

          } else {
            toast.error("Failed to save User Data");
            setShowConfirmModal(false);

          }
        })
        .catch((error) => {
          setReloadUserID(false);
          setShowConfirmModal(false);

          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";

          if (status === 500 && error.response?.data?.status_code === "ERR5") {
            toast.error(message);
          } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/college/"), 5000);
          } else if (error.response?.data?.status_code === 'ERR64' && status === 500) {
            toast.error("Something went wrong. Please try again");
            setReloadUserID(true);
            setErrors(prev => ({
              ...prev,
              userid: "Note: New user ID is generated. Please submit again"
            }));
          }
          if (error.response?.data?.http_status === 401 && error.response?.data?.status_code === "ERR43") {
            toast.error(message);
          }
          else {
            toast.error("Something went wrong");
          }
        });
    }

  };



  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      textAlign: 'left', // added
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
      textAlign: 'left', // added
    }),
    singleValue: (provided) => ({
      ...provided,
      textAlign: 'left', // optional, for selected value
    }),
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };
  console.log("errors.password", errors.password)
  return (
    <>
      <ToastContainer />
      <Template>


        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Add Users</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="col-md-12 txt-aln pdg14">
                        <div className="row">
                          <div className="col">

                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">User Role <span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <Select
                                  id="userType"
                                  name="userType"
                                  maxMenuHeight={200}
                                  menuPlacement="auto"
                                  styles={customStyles}
                                  className="form-control ht"
                                  options={[
                                    { value: 23, label: 'Additional Chief Superintendent(ACS)' },
                                    { value: 5, label: 'Data Entry Operator(DEO)' },
                                    { value: 24, label: 'Internship Manager User(IMU)' },
                                    { value: 22, label: 'Senior Faculty Advisor(SFA)' },

                                  ]}
                                  value={selectedUserType}
                                  onChange={handleUserTypeChange}
                                />
                                {errors.userType && <p className="text-danger">{errors.userType}</p>}
                              </div>
                            </div>
                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">User Name <span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <input type="text" className="form-control input-air-primary" name="username" value={username} onChange={(e) => setUsername(e.target.value)}
                                />
                                {errors.username && <p className="text-danger">{errors.username}</p>}
                              </div>
                            </div>
                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Phone No.<span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <input className="form-control input-air-primary"
                                  type="text"
                                  id="phone"
                                  name="phone"
                                  value={phone}
                                  maxLength={14}
                                  inputMode="numeric"
                                  pattern="[0-9+]*"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^[\d+]*$/.test(value)) {
                                      setPhone(value);
                                    }
                                  }}
                                />
                                {errors.phone && <p className="text-danger">{errors.phone}</p>}
                              </div>
                            </div>
                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Email ID<span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <input className="form-control input-air-primary" type="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                {errors.email && <p className="text-danger">{errors.email}</p>}
                              </div>
                            </div>

                            {userTypeId !== 23 && userTypeId !== 24 && (
                              <div className="row">
                                <label className="col-md-5 txt-aln-lft">Department/Discipline <span className="errorclr">*</span></label>
                                <div className="col-md-7">
                                  <Select
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="discipline_id"
                                    name="discipline_id"
                                    className="form"
                                    styles={customStyles}
                                    onChange={handleDisciplineChange}
                                    options={flag
                                      ? [{ value: '0', label: 'No data found' }]
                                      : disciplinedata
                                        .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                        .map(disciplines => ({
                                          did: disciplines.discipline_id,
                                          value: disciplines.discipline_name,
                                          label: disciplines.college_discipline_id == 1
                                            ? `${disciplines.discipline_name} - Single Faculty Course`
                                            : disciplines.discipline_name,
                                          type: disciplines.college_course_type,
                                          college_discipline_id: disciplines.college_discipline_id
                                        }))
                                    }
                                    value={
                                      disciplinedata
                                        .map(d => ({
                                          did: d.discipline_id,
                                          value: d.discipline_name,
                                          label: d.college_discipline_id == 1
                                            ? `${d.discipline_name} - Single Faculty Course`
                                            : `${d.discipline_name}`,
                                          type: d.college_course_type,
                                          college_discipline_id: d.college_discipline_id
                                        }))
                                        .find(option => option.did == disciplineId && option.type == disciplinetype) || null
                                    }

                                  />
                                  {errors.discipline && <p className="text-danger">{errors.discipline}</p>}
                                </div>

                              </div>
                            )}

                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Login User ID<span className="errorclr">*</span></label>
                              <div className="col-md-7">
                                <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                  <input
                                    className="form-control input-air-primary"
                                    type="text"
                                    name="userid"
                                    id="userid"
                                    value={userid}
                                    onChange={(e) => setUserID(e.target.value)}
                                    readOnly
                                    style={{ flex: 1 }}
                                  />

                                  <button
                                    type="button"
                                    className="reload-btn-c "
                                    style={{
                                      padding: "0.25rem 0.5rem",
                                      fontSize: "17px"
                                    }}
                                    onClick={copyUserIDToClipboard}
                                    title="Copy User ID"
                                  >Copy</button>
                                </div>
                                {errors.userid && <p className="text-danger">{errors.userid}</p>}
                              </div>
                            </div>

                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">
                                Password<span className="errorclr">*</span>
                              </label>
                              <div className="col-md-7">
                                <div className="position-relative">
                                  <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                    <input
                                      className="form-control input-air-primary"
                                      type="text"
                                      name="password"
                                      value={password}
                                      maxLength={12}

                                      onChange={(e) => {
                                        const val = e.target.value;
                                        setPassword(val);
                                        evaluateStrength(val);
                                      }}

                                      placeholder="Generated Password"
                                      style={{ flex: 2 }}
                                    />

                                    <button
                                      type="button"
                                      className="reload-btn "
                                      style={{
                                        padding: "0.25rem 0.5rem",
                                        fontSize: "17px"
                                      }}
                                      onClick={generatePassword}
                                      title="Generate new password"
                                    >
                                      <i className="fa fa-refresh" aria-hidden="true"></i>
                                    </button>

                                    <button
                                      type="button"
                                      className="reload-btn-c "
                                      style={{
                                        padding: "0.25rem 0.5rem",
                                        fontSize: "17px"
                                      }}
                                      onClick={copyToClipboard}
                                      title="Copy password"
                                    >Copy</button>
                                  </div>

                                  <small
                                    className={`password-strength text-${passwordStrength === "Very Strong"
                                      ? "success"
                                      : passwordStrength === "Strong"
                                        ? "warning"
                                        : "danger"
                                      }`}
                                  >
                                    {passwordStrength}
                                    {errors.password && <p className="text-danger">{errors.password}</p>}
                                  </small>

                                  <span>
                                    {(!errors.password) && (
                                      <p style={{ color: '#696c6f' }}>Password must be 8-12 characters, start with uppercase, followed by lowercase,number and symbol.</p>
                                    )}
                                    <p style={{ color: 'red' }}> You can enter or click <i className="fa fa-refresh reload-i" aria-hidden="true"></i> to generate password </p>
                                  </span>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <button className="btn btn-primary me-3" type="submit" onClick={handlefirstsubmit}>Submit</button>
                          <input className="btn btn-light" type="reset" style={{ border: '2px solid black' }} value="Cancel" onClick={cancelForm} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {showConfirmModal && (
              <div className="modal-backdrop show" style={{ opacity: 'unset' }}>
                <div className="modal d-block" tabIndex="-1" role="dialog">
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Confirmation</h5>
                      </div>
                      <div className="modal-body">
                        <p style={{ color: 'green' }}>
                          An email has been sent to the user at <strong>{email}</strong>.
                        </p>
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={() => {
                          setShowConfirmModal(false);
                          setTimeout(() => {
                            cancelForm();
                          }, 1000);
                        }}>
                          OK
                        </button>
                        {/* <button type="button" className="btn btn-secondary" onClick={() => setShowConfirmModal(false)}>
                          Cancel
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </Template>
    </>
  );
}